import {JsonObject, JsonProperty} from 'json2typescript';

@JsonObject('KovanHrOrganizationSchemaModel')
export class OrganizationSchemaModel {
    @JsonProperty('id', Number, true)
    id: number = null;

    @JsonProperty('parentId', Number, true)
    parentId: number = null;

    @JsonProperty('name', String, true)
    name: string = null;

    @JsonProperty('surname', String, true)
    surname: string = null;

    @JsonProperty('organizationName', String, true)
    organizationName: string = null;

    @JsonProperty('pictureUuid', String, true)
    pictureUuid: string = null;
}
